export function toRequestAsyncSelectItems(items) {
  return items.map(item => ({
    additionalData: item.address_obj?.value,
    label: item.title,
    value: item.id,
  }))
}

export function getRequestItemTagText(item) {
  return item.label
}
